import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StorageUtils from "@src/utils/storageUtils";
import { USER_COOKIE } from "@src/constants/constants";
import SignolUtils from "./signolUtils";

export function useCheckIdentityId() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!!location?.search) {
      const params = new URLSearchParams(location.search);
      const encodedIdentityId = params.get("identityId");

      if (!encodedIdentityId) return;

      const targetLocationExists = StorageUtils.getItem("targetLocation");

      try {
        const identityId = atob(encodedIdentityId);
        const storedUser = StorageUtils.getObjectItem(USER_COOKIE);

        if (storedUser) {
          const userId = storedUser.id;
          if (identityId !== userId) {
            SignolUtils.removeSessionCookies();
            if (!targetLocationExists) {
              StorageUtils.setItem("targetLocation", location.pathname);
            }
            // Optional: log mismatch somewhere
            navigate("/login", { replace: true });
          }
        } else {
          if (!targetLocationExists) {
            StorageUtils.setItem("targetLocation", location.pathname);
          }
          navigate("/login", { replace: true });
        }
      } catch (error) {
        if (!targetLocationExists) {
          StorageUtils.setItem("targetLocation", location.pathname);
        }
        // Optional: log error somewhere
        navigate("/login", { replace: true });
      }
    }
  }, [location.search, location.pathname, navigate]);
}
